<template>
  <q-form ref="form" class="full-width q-px-md">
    <div class="row">
      <div class="col-12 q-pa-xs">
        <q-input
          v-model="formData.name"
          label="Name"
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>
      <div class="col-12 col-sm-6 q-pa-xs">
        <q-select
          v-model="formData.section"
          label="Section"
          v-bind="siteCFG.fields.general"
          :options="['Design', 'Officiating', 'Entries']"
        >
        </q-select>
      </div>
      <div class="col-12 col-sm-6 q-pa-xs">
        <q-select
          v-model="formData.status"
          label="Status"
          v-bind="siteCFG.fields.general"
          :options="['draft', 'live']"
        >
        </q-select>
      </div>
      <div class="col-12 q-pa-xs">
        <q-input
          v-model="formData.youtubeLink"
          label="Youtube Video ID (e.g. V8CqgMsNXC4)"
          v-bind="siteCFG.fields.general"
          hint="Found in the youtube url, after the v=V8CqgMsNXC4 (https://www.youtube.com/watch?v=V8CqgMsNXC4)"
        >
        </q-input>
      </div>
      <div class="col-12">
        <div class="row items-center text-center">
          <div class="col">
            <div
              v-if="changeImage || !formData.thumbnail"
              style="margin: auto; width: 300px;"
            >
              <croppa
                ref="imgCroppa"
                :height="300"
                :width="200"
                :show-remove-button="true"
                v-model="myCroppa"
                remove-button-color="#68c6d2"
                :show-loading="true"
                :loading-size="50"
                crossOrigin="anonymous"
                :quality="2"
                :prevent-white-space="false"
                :placeholder="'Choose an image (300x200)'"
                :placeholder-font-size="15"
              >
              </croppa>
              <q-btn
                class="full-width"
                color="negative"
                label="Cancel"
                @click="
                  changeImage = false;
                  myCroppa = null;
                "
              >
              </q-btn>
            </div>
            <div v-else style="margin: auto; width: 300px">
              <q-img
                :src="formData.thumbnail"
                style="height: 300px; width: 200px"
              >
              </q-img>
              <q-btn
                class="full-width"
                color="primary"
                label="Change"
                @click="changeImage = true"
              >
              </q-btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </q-form>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      siteCFG: "settings/siteCFG",
      data: "tutorials/current",
      dataLoading: "tutorials/currentLoading"
    })
  },
  props: {
    id: {
      default: null
    }
  },
  watch: {
    id: function() {
      this.init();
    },
    data: function() {
      this.init();
    }
  },
  data: () => ({
    // Extra Data
    formData: {
      status: "draft"
    },
    tab: "general",

    // Croppa
    changeImage: false,
    myCroppa: null
  }),
  beforeCreate() {},
  mounted() {
    this.init();
    this.$store.dispatch("tutorials/loadByID", this.id);
  },
  methods: {
    init() {
      if (this.data != null && this.data.id == this.id) {
        this.formData = JSON.parse(JSON.stringify(this.data));
      } else {
        this.formData = {
          status: "draft"
        };
      }
    },
    create() {
      this.$emit("loadingStateChanged", true);

      this.$refs.form.validate().then(result => {
        if (result) {
          if (this.myCroppa && this.myCroppa.imageSet) {
            this.formData.image = {
              dataUrl: this.myCroppa.generateDataUrl()
            };
          } else {
            delete this.formData.image;
          }
          let payload = JSON.parse(JSON.stringify(this.formData));
          this.$store.dispatch("tutorials/new", payload).then(result => {
            this.$emit("loadingStateChanged", false);
            if (result.Result == "Success") {
              this.$emit("close", true);
              this.formData = {};
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: result.Response.Message
              });
            }
          });
        } else {
          this.$emit("loadingStateChanged", false);
        }
      });
    },
    save() {
      this.$emit("loadingStateChanged", true);

      if (this.myCroppa && this.myCroppa.imageSet) {
        this.formData.image = {
          dataUrl: this.myCroppa.generateDataUrl()
        };
      } else {
        delete this.formData.image;
      }
      let payload = JSON.parse(JSON.stringify(this.formData));

      this.$store.dispatch("tutorials/save", payload).then(result => {
        this.$emit("loadingStateChanged", false);
        if (result.Result == "Success") {
          this.address = "";
          this.$emit("close", true);
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later"
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.formSubTitle {
  font-weight: bold;
}
</style>
